export default __webpack_public_path__ + "static/media/isle-cert.be44d26f.webp";